module.exports = __webpack_public_path__ + "img/Find-a-Doctor.df72be59.png";